export enum SportWagerTypeEnum {
  STRAIGHT_BET = 0,
  PARLAY = 1,
  _2TEAM_TEASER_Ties_Push = 2,
  _3TEAM_SUPER_TEAS_TIES_LOSE = 2,
  _3TEAM_TEASER_Ties_Push = 2,
  _4TEAM_SUPER_TEAS_TIES_LOSE = 2,
  _4TEAM_TEASER_Ties_Push = 2,
  _5TEAM_TEASER_Ties_Push = 2,
  _6TEAM_TEASER_Ties_Push = 2,
  _7TEAM_TEASER_Ties_Push = 2,
  _8TEAM_TEASER_Ties_Push = 2,
  IF_WIN = 3,
  REVERSE_WIN = 4,
  ROUND_ROBIN = 5,
  ACTION_POINTS = 6,
  IF_WIN_OR_TIE = 7,
  REVERSE_ACTION = 8,
  BLOCK = 9,
  IF_LOSE = 10,
  IF_LOSE_OR_TIE = 11,
  RACING_BET = 12,
  CARD_BET = 14,
  COMPACT_ROUND_ROBIN = 15,
  KEY_PARLAY = 16,
  COMPACT_IF_WIN = 17,
  COMPACT_IF_WIN_OR_TIE = 18,
  COMPACT_IF_LOSE = 19,
  COMPACT_IF_LOSE_OR_TIE = 20,
  COMPACT_REVERSE_WIN = 21,
  COMPACT_REVERSE_ACTION = 22,
  Rapid_Bet = 23,
  eSPORT_STRAIGHT_BET = 24,
  PROPS_BUILDER = 25,
  PROPS_BUILDER_WIDGET = 26,
  Pana_Apuestas = 27,
  Star_Sports = 28,
  Ultralive = 29,
  SportCast = 35,
}
